import { memo } from "react";
import ScoreCellContainer from "./ScoreCell.styles";

type Props = {
    score: number | null;
};

const ScoreCell = memo(function ScoreCell({ score }: Props) {
    if (score === null) {
        return null;
    }

    return (
        <ScoreCellContainer className={`score-${score}`}>
            {score}
        </ScoreCellContainer>
    );
});

export default ScoreCell;
